const startsWithSlashRegex = /^\/(?!\/)/

export const isInternalLink = to => startsWithSlashRegex.test(to)